export enum AppEvents {
  APP_LOG_OUT = 'app-log-out',
  HTTP_ERROR = 'http-error',
  HTTP_SUCCESS = 'http-success',
  HTTP_WARNING = 'http-warning',
}
